var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChangePasswordIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.4668C1 15.0728 1 13.3757 2.05442 12.3213C3.10883 11.2668 4.80588 11.2668 8.2 11.2668H17.8C21.1941 11.2668 22.8911 11.2668 23.9456 12.3213C25 13.3757 25 15.0728 25 18.4668C25 21.8609 25 23.558 23.9456 24.6124C22.8911 25.6668 21.1941 25.6668 17.8 25.6668H8.2C4.80588 25.6668 3.10883 25.6668 2.05442 24.6124C1 23.558 1 21.8609 1 18.4668Z",
    stroke: "#F3223C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.7998 11.2668V8.86675C5.7998 4.8903 9.02335 1.66675 12.9998 1.66675C16.9762 1.66675 20.1998 4.8903 20.1998 8.86675V11.2668",
    stroke: "#F3223C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePasswordIcon);
export default __webpack_public_path__ + "static/media/ChangePasswordIcon.fb5a116c6174e46a91f5cb51277d53a7.svg";
export { ForwardRef as ReactComponent };